/* eslint-disable react/display-name */
import React, { memo } from 'react';
import loadable from '@loadable/component';
import {
  Container as ContentLibraryContainer,
  ContainerProps,
} from '@johnlewispartnership/wtr-content-component-library';
import OnboardingContent from './OnboardingContent/OnboardingContent';

const GLPNav = loadable(() => import('components/GroceriesLandingPage/Navigation'));

const GLP_ELEMENT_ID_PREFIX = 'glp-nav-component';
const ONBOARDING_ELEMENT_ID = 'onboarding-content-container';

const hasElementIdPrefix = (expectedId: string, elementId?: string) =>
  elementId?.startsWith(expectedId) ?? false;

const withContainerReplacements = (ContainerComponent: typeof ContentLibraryContainer) => {
  const ContainerWrapper = memo((props: ContainerProps) => {
    if (hasElementIdPrefix(GLP_ELEMENT_ID_PREFIX, props.elementId)) {
      return <GLPNav />;
    }

    if (hasElementIdPrefix(ONBOARDING_ELEMENT_ID, props.elementId)) {
      return <OnboardingContent {...props} />;
    }

    return <ContainerComponent {...props} />;
  });

  return ContainerWrapper;
};

export default withContainerReplacements;
